export default function () {
	return {
		loading: 0,
		mobile: false,
	};
}
